const car = window.location.search.split('&')[1];

const state={
	car:1
}

if(car){
	state.car=+car;
}

export default state;
